import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PlumbingDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PlumbingDescription: React.FC<PlumbingDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [plumbing, set_plumbing] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['Plumbing']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'Plumbing': [v, b.values?.['Major Systems']?.['Plumbing']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={plumbing}
                />
            ) : (
                <TextBox
                    value={plumbing}
                    onChange={(value) => set_plumbing(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
